window._ = require('lodash');

try {
    window.Popper = require('@popperjs/core').default;

} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Import bootstrap specific items, only import the ones you need.
 */
import {
    Alert,
    Collapse,
    Dropdown,
    Modal,
    Tab,
    Tooltip,
    Popover
} from 'bootstrap';

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Enable BS Tooltips everywhere
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
tooltipTriggerList.map((tooltipTriggerEl) => {
    return new Tooltip(tooltipTriggerEl)
});

// Enable BS Popovers everywhere
const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl)
})

/**
 * Import Animate on Scroll plugin
 */
import AOS from 'aos';

// Init Animate On Scroll
AOS.init();

// Smooth scroll
if (document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        });
    });
}
